// Small canvas shapes shared by the holiday animations. Each is drawn centred on (x, y).

export const drawHeart = (ctx: CanvasRenderingContext2D, x: number, y: number, size: number) => {
  ctx.beginPath();
  ctx.arc(x - size / 2, y, size / 2, Math.PI, 0);
  ctx.arc(x + size / 2, y, size / 2, Math.PI, 0);
  ctx.lineTo(x, y + size * 1.1);
  ctx.closePath();
  ctx.fill();
};

export const drawClover = (ctx: CanvasRenderingContext2D, x: number, y: number, size: number) => {
  for (let i = 0; i < 4; i++) {
    const angle = (i * Math.PI) / 2 + Math.PI / 4;
    ctx.beginPath();
    ctx.arc(x + Math.cos(angle) * size * 0.55, y + Math.sin(angle) * size * 0.55, size * 0.5, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.strokeStyle = ctx.fillStyle;
  ctx.lineWidth = Math.max(1, size * 0.18);
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.quadraticCurveTo(x + size * 0.3, y + size, x - size * 0.2, y + size * 1.6);
  ctx.stroke();
};

/** `spin` is an angle; the coin narrows as it turns so it looks like it's flipping. */
export const drawCoin = (ctx: CanvasRenderingContext2D, x: number, y: number, size: number, spin: number) => {
  ctx.fillStyle = '#e8b923';
  ctx.strokeStyle = '#9c7410';
  ctx.lineWidth = 1;
  ctx.beginPath();
  ctx.ellipse(x, y, Math.max(0.6, Math.abs(Math.cos(spin)) * size), size, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();
};
